const MODULE_CHANGE_EVENT =
  "chinook-edge-mentor-active-module-change";

let registrationSequence = 0;
const registrations = new Map();
let activeModule = null;

const normalizeModuleKey = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-")
    .replace(/^-+|-+$/g, "") || "default";

const publishActiveModule = () => {
  const nextActive = Array.from(
    registrations.values(),
  )
    .sort((a, b) => a.sequence - b.sequence)
    .at(-1) || null;

  activeModule = nextActive
    ? {
        moduleKey: nextActive.moduleKey,
        moduleName: nextActive.moduleName,
      }
    : null;

  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(MODULE_CHANGE_EVENT, {
        detail: activeModule,
      }),
    );
  }
};

export const registerEdgeMentorModule = (
  moduleKey,
  moduleName,
) => {
  const normalizedKey =
    normalizeModuleKey(moduleKey);

  registrationSequence += 1;

  const token =
    `${normalizedKey}-${registrationSequence}`;

  registrations.set(token, {
    moduleKey: normalizedKey,
    moduleName:
      String(moduleName ?? "").trim() ||
      normalizedKey,
    sequence: registrationSequence,
  });

  publishActiveModule();

  return () => {
    registrations.delete(token);
    publishActiveModule();
  };
};

export const getActiveEdgeMentorModule = () =>
  activeModule;

export const subscribeToActiveEdgeMentorModule = (
  callback,
) => {
  if (typeof window === "undefined") {
    return () => {};
  }

  const handler = () => {
    callback?.(getActiveEdgeMentorModule());
  };

  window.addEventListener(
    MODULE_CHANGE_EVENT,
    handler,
  );

  return () => {
    window.removeEventListener(
      MODULE_CHANGE_EVENT,
      handler,
    );
  };
};
